'use client';

import { QuestionMarkCircledIcon, Cross2Icon, FileTextIcon } from "@radix-ui/react-icons";
import { ModeToggle } from "./toggle-theme";
import { Button } from "@/components/ui/button";
import { motion } from "framer-motion";
import BtnMail from "./btn-mail";
import BtnLinkedIn from "./btn-lin";
import BtnPrompts from "./btn-prompts";
import { cn } from "@/lib/utils";
import Image from "next/image";
import BtnDownload from "./btn-download";

interface MenuProps {
    onHomeClick: () => void;
    onAboutClick: () => void;
    sendMessage: (content: string) => void;
    isOpen: boolean;
}

function downloadPdf() {
    const link = document.createElement('a');
    link.href = '/david_andersson_resume.pdf';
    link.download = 'david_andersson_resume.pdf';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
}

export default function Menu({ onAboutClick, onHomeClick, sendMessage, isOpen }: MenuProps) {
    return (
        <motion.div
            initial={{ y: -100, opacity: 0 }}
            animate={{ y: 0, opacity: 1 }}
            transition={{ duration: 0.8, ease: "easeOut" }}
            className="absolute text-xs flex justify-between w-full py-2 top-0 left-0 z-1000 text-muted-foreground bg-background/50 backdrop-blur-md border-b border-border will-change-transform transform-gpu"
        >

            {/* Mobile */}
            <div className="w-full md:hidden">
                <div className="flex items-center px-6 justify-between w-full">
                    <div onClick={onHomeClick}>
                        <Image priority src={"/logo_white.svg"} className="hidden aspect-square transform transition-all duration-100 dark:block" width={20} height={20} alt="108 Capital" />
                        <Image src={"/logo_black.svg"} className="aspect-square transform transition-all duration-100 dark:hidden" width={20} height={20} alt="108 Capital" />
                    </div>
                    <div>
                        <Button variant="ghost" size="icon" onClick={onAboutClick}>
                            {isOpen ? <Cross2Icon /> : <QuestionMarkCircledIcon />}
                        </Button>
                    </div>
                    <div><BtnDownload onClick={downloadPdf} /></div>
                    <div className={cn("", isOpen ? "opacity-0 pointer-events-none" : "opacity-100")}><BtnPrompts sendMessage={sendMessage} /></div>
                    <div><BtnMail /></div>
                    <div><BtnLinkedIn /></div>
                    {/* <div><ModeToggle /></div> */}
                </div>
            </div>

            {/* Desktop */}
            <div className="hidden w-full md:flex md:justify-between">
                <div className="flex items-center gap-6 px-10">
                    <div onClick={onHomeClick} className="cursor-pointer mr-2">
                        <Image priority src={"/logo_white.svg"} className="hidden aspect-square transform transition-all duration-100 dark:block" width={20} height={20} alt="108 Capital" />
                        <Image src={"/logo_black.svg"} className="aspect-square transform transition-all duration-100 dark:hidden" width={20} height={20} alt="108 Capital" />
                    </div>
                    <div className="flex items-center gap-2 cursor-pointer hover:text-foreground transition-colors" onClick={onAboutClick}>
                        {isOpen ? <Cross2Icon /> : <QuestionMarkCircledIcon />}
                        {isOpen ? "Close" : "About"}
                    </div>
                    <div className="flex items-center  gap-2 cursor-pointer hover:text-foreground transition-colors" onClick={downloadPdf}>
                        <FileTextIcon /> Resume
                    </div>

                    {!isOpen && <BtnPrompts sendMessage={sendMessage} />}

                </div>

                <div className="flex px-10 gap-6">
                    <BtnMail />
                    <BtnLinkedIn />
                    <ModeToggle />
                </div>
            </div>
        </motion.div >
    );
}